import memoize from 'transmute/memoize';
import { useState, useEffect } from 'react';
import { getCrmObjectName, isSupportedCrmObject
// @ts-expect-error Untyped dependency
} from 'reporting-data/crmObjects/utils';
import { waitForPromises } from 'reporting-ui-components/lib/waitForPromises';
const getCustomObjectLabel = memoize(dataType => isSupportedCrmObject(dataType) ? getCrmObjectName(dataType) : Promise.resolve());
export const useCustomObjectLabel = ({
  dataType
}) => {
  const [customObjectLabel, setCustomObjectLabel] = useState({
    status: 'pending',
    value: undefined,
    error: undefined
  });
  useEffect(() => {
    waitForPromises({
      customObjectLabel: {
        setStateFunction: setCustomObjectLabel,
        promise: getCustomObjectLabel(dataType)
      }
    });
  }, [dataType]);
  return customObjectLabel;
};